// extracted by mini-css-extract-plugin
export default {"media_block":"media_block___VSH35","text":"text___w28mZ","img":"img___nPuzb","reversed":"reversed___KE0o_"};